export default "/images/f9b1f32e8fd7a788a641dfc5a8fd9b7a.avif";